import { useQueryClient } from "@tanstack/react-query";
import { invalidateOpportunitiesTableQueries } from "../queries/invalidate-opportunities-table";

export async function invalidateOpportunityHandlingQueries(
  queryClient: ReturnType<typeof useQueryClient>,
  opportunityId: string,
) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["event-card", opportunityId] }),
    queryClient.invalidateQueries({ queryKey: ["association-requested-table"] }),
    invalidateOpportunitiesTableQueries(queryClient),
  ]);
}
